import { ReactNode } from 'react';
import styled from 'styled-components';

import CircularProgress from 'components/shared/CircularProgress';
import { colors } from 'styles/theme/colors';

import { TilesGrid } from './statTiles';

type Props = {
  tiles: ReactNode;
  chartTitle: string;
  chartLoading: boolean;
  showChart?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
};

export default function MetricDetailLayout({
  tiles,
  chartTitle,
  chartLoading,
  showChart = true,
  isEmpty = false,
  emptyMessage = '\u2014',
  children,
}: Props) {
  return (
    <Wrapper>
      <TilesGrid>{tiles}</TilesGrid>
      {showChart && (
        <ChartCard>
          <ChartTitle>{chartTitle}</ChartTitle>
          {chartLoading ? (
            <ChartPlaceholder>
              <CircularProgress color={colors.primaryBlue} size={28} thickness={3} />
            </ChartPlaceholder>
          ) : isEmpty ? (
            <ChartPlaceholder>{emptyMessage}</ChartPlaceholder>
          ) : (
            children
          )}
        </ChartCard>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ChartCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.black10};
  border-radius: 4px;
  padding: 20px 22px;
`;

const ChartTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  letter-spacing: 0.18px;
  margin-bottom: 16px;
`;

const ChartPlaceholder = styled.div`
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black25};
`;
